
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'checkout-shipping-methods-default',
})
export default class extends Vue {
  @Prop({ required: true }) private shippingMethod: object;
  @Prop() private selectedShippingMethod: object;

  private get isActiveMethod(): boolean {
    return (this.selectedShippingMethod || {})['method_code'] === this.shippingMethod['method_code'];
  }

  private get getMethodTitle(): string {
    const extensionAttributes = this.shippingMethod['extension_attributes'] || {};
    const titleCandidates = [
      this.shippingMethod['method_title'],
      this.shippingMethod['carrier_title'],
      extensionAttributes['amstrates_comment'],
      extensionAttributes['amstartes_comment'],
    ];

    for (const titleCandidate of titleCandidates) {
      const sanitizedTitle = this.sanitizeMethodTitle(titleCandidate);

      if (sanitizedTitle.length > 0) {
        return sanitizedTitle;
      }
    }

    return this.shippingMethod['method_code'] || this.shippingMethod['carrier_code'] || '';
  }

  private sanitizeMethodTitle(value: unknown): string {
    if (typeof value !== 'string') {
      return '';
    }

    return value.replace(/#.*$/, '').trim();
  }

  private get deliveryOptions(): Array<object> {
    const extensionAttributes = this.shippingMethod['extension_attributes'] || {};
    const deliveryOptions = extensionAttributes['delivery_options'];

    return this.parseDeliveryOptions(deliveryOptions);
  }

  private parseDeliveryOptions(deliveryOptions: unknown): Array<object> {
    if (!deliveryOptions) {
      return [];
    }

    if (Array.isArray(deliveryOptions)) {
      return deliveryOptions.filter(this.isDeliveryOption).map((option) => option as object);
    }

    if (typeof deliveryOptions === 'string') {
      const trimmed = deliveryOptions.trim();
      if (!trimmed.length) {
        return [];
      }

      try {
        return this.parseDeliveryOptions(JSON.parse(trimmed));
      } catch (e) {
        return [];
      }
    }

    if ('object' === typeof deliveryOptions) {
      return Object.values(deliveryOptions)
        .filter(this.isDeliveryOption)
        .map((option) => option as object);
    }

    return [];
  }

  private isDeliveryOption(option: unknown): option is object {
    return !!option && typeof option === 'object';
  }

  private async changeSelectedShippingMethod(method): Promise<void> {
    await this.$store.dispatch('CheckoutShipping/setShippingMethod', method);
    const shippingMethodOptions = this.deliveryOptions;

    if (shippingMethodOptions.length === 0) {
      this.$store.dispatch('CheckoutShipping/setDeliveryOption', '');
      return;
    }

    const hasValidDeliveryOption = shippingMethodOptions.some(
      (option) => option['code'] === this.selectedDeliveryOption
    );

    if (!hasValidDeliveryOption) {
      this.$store.dispatch('CheckoutShipping/setDeliveryOption', shippingMethodOptions[0]['code']);
    }
  }

  private get selectedDeliveryOption(): string {
    return this.$store.getters['CheckoutShipping/deliveryOption'];
  }
}
